export default __webpack_public_path__ + "static/media/480_dummy2016-heilpraxis01-mobile-de.7492dc9e.png";